import * as React from "react";
import { useToggle } from "react-use";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ReviewVerdictBadge } from "@/modules/snapshots/grid/reviewVerdictBadge";
import type { SnapshotCellReview, SnapshotCellReviewDetails } from "@/modules/snapshots/businessReports.types";

interface Props {
  review: SnapshotCellReview | SnapshotCellReviewDetails;
  onOpenComparison?: () => void;
}

export const GridSidebarReviewSection: React.FC<Props> = ({ review, onOpenComparison }) => {
  const [showDetails, toggleShowDetails] = useToggle(false);
  if (!review.verdict) return null;
  const detailedExplanation = "detailed_explanation" in review ? review.detailed_explanation : null;
  const secondResponse = "second_response" in review ? review.second_response : null;

  return (
    <div className="mt-4 rounded-md border border-gray-200 p-3">
      <div className="flex flex-wrap items-center gap-2">
        <ReviewVerdictBadge verdict={review.verdict} />
        {review.short_explanation && <span className="text-sm text-gray-600">{review.short_explanation}</span>}
      </div>
      {detailedExplanation && (
        <div className="mt-2">
          <button
            type="button"
            onClick={toggleShowDetails}
            className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700"
          >
            {showDetails ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
            {showDetails ? "Hide details" : "Show details"}
          </button>
          {showDetails && <p className="mt-1 text-sm text-gray-700">{detailedExplanation}</p>}
        </div>
      )}
      {secondResponse && onOpenComparison && (
        <Button type="button" variant="outline" size="sm" className="mt-3" onClick={onOpenComparison}>
          Compare responses
        </Button>
      )}
    </div>
  );
};
